<div class="youtube-source-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ (isEdit ? 'SETTINGS.YOUTUBE_SOURCE.EDIT' : 'SETTINGS.YOUTUBE_SOURCE.CREATE') | translate }}</span>
		<button mat-icon-button (click)="cancel()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<form [formGroup]="form" (ngSubmit)="save()">
			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.YOUTUBE_SOURCE.NAME' | translate }}</mat-label>
					<input matInput formControlName="name" cdkFocusInitial />
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.YOUTUBE_SOURCE.URL' | translate }}</mat-label>
					<input matInput formControlName="url" placeholder="https://www.youtube.com/@channel or /playlist?list=..." />
					<mat-hint>{{ 'SETTINGS.YOUTUBE_SOURCE.URL_HINT' | translate }}</mat-hint>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.YOUTUBE_SOURCE.KEYWORDS' | translate }}</mat-label>
					<mat-chip-grid #keywordsChipGrid>
						@for (keyword of keywords; track keyword) {
						<mat-chip-row (removed)="removeKeyword(keyword)">
							{{ keyword }}
							<button matChipRemove>
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-row>
						}
					</mat-chip-grid>
					<input
						matInput
						[matChipInputFor]="keywordsChipGrid"
						[matChipInputSeparatorKeyCodes]="separatorKeyCodes"
						(matChipInputTokenEnd)="addKeyword($event)" />
					<mat-hint>{{ 'SETTINGS.YOUTUBE_SOURCE.KEYWORDS_HINT' | translate }}</mat-hint>
				</mat-form-field>
			</div>

			<div class="row">
				<mat-form-field class="w-100 pb-2">
					<mat-label>{{ 'SETTINGS.YOUTUBE_SOURCE.CUSTOM_SCHEDULE_TIMES' | translate }}</mat-label>
					<mat-chip-grid #scheduleTimesChipGrid>
						@for (time of scheduleTimes; track time) {
						<mat-chip-row (removed)="removeScheduleTime(time)">
							{{ time }}
							<button matChipRemove>
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-row>
						}
					</mat-chip-grid>
					<input
						matInput
						placeholder="08:00"
						[matChipInputFor]="scheduleTimesChipGrid"
						[matChipInputSeparatorKeyCodes]="separatorKeyCodes"
						(matChipInputTokenEnd)="addScheduleTime($event)" />
					<mat-hint>{{ 'SETTINGS.YOUTUBE_SOURCE.CUSTOM_SCHEDULE_TIMES_HINT' | translate }}</mat-hint>
				</mat-form-field>
			</div>

			<div class="row pb-2">
				<mat-checkbox formControlName="enabled">{{ 'SETTINGS.YOUTUBE_SOURCE.ENABLED' | translate }}</mat-checkbox>
			</div>
		</form>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="pe-4">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="gap-2 d-flex justify-content-end pt-0">
			<button mat-flat-button type="button" color="primary" (click)="save()" [disabled]="form.invalid || saving">
				{{ 'BUTTON.SAVE' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="cancel()">
				{{ 'BUTTON.CANCEL' | translate }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
